import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column nowrap',
    gap: theme.spacing(3),
  },
  warningArea: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    '&:empty': { marginBottom: 0, display: 'none' },
  },
  mainContent: {
    display: 'flex',
    flexFlow: 'column',
    gap: theme.spacing(3),
    alignItems: 'stretch',
    minWidth: 0,
  },
  infoArea: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch',
    gap: theme.spacing(3),
    minWidth: 0,
    '& > *': { flexShrink: 0, flexGrow: 0 },
  },
  contentArea: {
    display: 'flex',
    flexFlow: 'column',
    gap: theme.spacing(3),
    alignItems: 'stretch',
    minWidth: 0,
  },
  [theme.breakpoints.up('md')]: {
    root: {
      display: 'grid',
      gap: theme.spacing(3),
      gridTemplateAreas: `"content info" "content info"`,
      gridTemplateColumns: ({ infoCards }: { infoCards: boolean }) =>
        infoCards ? '2fr 1fr' : '1fr',
      alignItems: 'start',
    },
    mainContent: { display: 'contents' },
    contentArea: { gridArea: 'content' },
    infoArea: {
      gridArea: 'info',
      position: 'sticky',
      top: theme.spacing(3),
      maxHeight: '100vh',
      overflowY: 'auto',
      alignSelf: 'start',
      alignItems: 'stretch',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      '&::-webkit-scrollbar': { display: 'none' },
    },
  },
}));
